
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:51682"
const parsedApiUrl = new URL(API_URL)
const API_SCHEME = parsedApiUrl.protocol.replace(":", "")
const API_HOST_NAME = parsedApiUrl.hostname
const API_PORT = parsedApiUrl.port || (parsedApiUrl.protocol === "https:" ? "443" : "80")
const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || "zemus-jwt-v1"

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    API_URL,
    API_SCHEME,
    API_HOST_NAME,
    API_PORT,
    TOKEN_KEY
};



